import { JSX } from 'solid-js'

export type Perm = { byte: number; bit: number }

function gen_auto(): () => Perm {
    let bit = 0
    let byte = 0
    return () => {
        let perm: Perm = { bit: bit++, byte }
        if (bit > 7) {
            bit = 0
            byte++
        }
        return perm
    }
}

const auto = gen_auto()

export class Perms {
    static MASTER: Perm = auto()

    static V_USER: Perm = auto()
    static A_USER: Perm = auto()
    static C_USER: Perm = auto()
    static D_USER: Perm = auto()

    static V_EATERY: Perm = auto()
    static A_EATERY: Perm = auto()
    static C_EATERY: Perm = auto()
    static D_EATERY: Perm = auto()

    static V_DISH: Perm = auto()
    static A_DISH: Perm = auto()
    static C_DISH: Perm = auto()
    static D_DISH: Perm = auto()

    static V_RECORD: Perm = auto()
    static A_RECORD: Perm = auto()
    static C_RECORD: Perm = auto()
    static D_RECORD: Perm = auto()

    static V_DETAIL: Perm = auto()
    static A_DETAIL: Perm = auto()
    static C_DETAIL: Perm = auto()
    static D_DETAIL: Perm = auto()

    static V_REVIEW: Perm = auto()
    static A_REVIEW: Perm = auto()
    static C_REVIEW: Perm = auto()
    static D_REVIEW: Perm = auto()

    static V_EXTRA: Perm = auto()
    static A_EXTRA: Perm = auto()
    static C_EXTRA: Perm = auto()
    static D_EXTRA: Perm = auto()

    static V_ISSUE: Perm = auto()
    static A_ISSUE: Perm = auto()
    static C_ISSUE: Perm = auto()
    static D_ISSUE: Perm = auto()

    static CLONE_MENU: Perm = auto()
    static V_ETASKS: Perm = auto()
    static ABORT_ETASK: Perm = auto()
    static _UNUSED_3: Perm = auto()

    static V_BRAND: Perm = auto()
    static A_BRAND: Perm = auto()
    static C_BRAND: Perm = auto()
    static D_BRAND: Perm = auto()

    #perms: number[]
    constructor(perms: number[]) {
        perms = perms.map(p => Math.min(p, 255))

        for (let i = 64 - perms.length; i > 0; i--) {
            perms.push(0)
        }

        perms = perms.slice(0, 64)
        this.#perms = perms
    }

    any(): boolean {
        for (let p of this.#perms) {
            if (p != 0) return true
        }
        return false
    }

    any_of(...perms: Perm[]): boolean {
        for (let p of perms) {
            if (this.get(p)) return true
        }

        return false
    }

    check(...perms: Perm[]): boolean {
        if (this.get(Perms.MASTER)) return true

        for (let p of perms) {
            if (!this.get(p)) return false
        }

        return true
    }

    get({ byte, bit }: Perm): boolean {
        if (byte >= this.#perms.length) {
            throw new Error('invalid byte')
        }
        let f = 1 << bit
        let n = this.#perms[byte]!
        return (n & f) == f
    }

    set({ byte, bit }: Perm, value: boolean) {
        if (byte >= this.#perms.length) {
            throw new Error('invalid byte')
        }
        let f = 1 << bit
        if (value) {
            this.#perms[byte]! |= f
        } else {
            this.#perms[byte]! &= ~f
        }
    }

    get perms(): number[] {
        return this.#perms
    }
}
// @ts-ignore
delete globalThis.auto

export type PermDpy = {
    perm: Perm
    name: string
    type: 'view' | 'delete' | 'change' | 'add'
    icon: () => JSX.Element
}
export type PermDpyGroup = {
    name: string
    perms: PermDpy[]
}
